import { useEffect, useState } from "react";
import utils from "../universal/utils";

export function useCountriesList({ enabled = true } = {}) {
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);

    useEffect(() => {
        if (!enabled || hasFetched) return;

        const basePath = utils.getEdgeBasePath();
        setLoading(true);

        fetch(`${basePath}/api/v1/lobby/countries`)
            .then((response) => response.json())
            .then((data) => {
                if (data?.ok && Array.isArray(data.countries)) {
                    setCountries(data.countries);
                } else {
                    setCountries([]);
                }
            })
            .catch(() => setCountries([]))
            .finally(() => {
                setLoading(false);
                setHasFetched(true);
            });
    }, [enabled, hasFetched]);

    return { countries, loading };
}
